<template>
    <div class="checkbox"
         :class="{
            disabled: !!disabled
         }"
    >
        <input :checked="value"
               type="checkbox"
               name="remember"
               id="remember"
               @change="onCheckboxChangeEvent"
        />

        <label for="remember">
            <slot></slot>
        </label>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: 'name',
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        onCheckboxChangeEvent(event) {
            const value = event.target.value;

            this.$emit('update', this.name, value);
        },
    },
}
</script>